import { Navigate, Routes, Route, useParams } from "react-router-dom";
import { canAccessDashboard, isGuestOnly } from "@silph-scope/shared";
import { AppShell } from "./components/AppShell";
import { CatalogPage } from "./pages/CatalogPage";
import { CalendarPage } from "./pages/CalendarPage";
import { TaskOperationsPage } from "./pages/TaskOperationsPage";
import { DeliveryTimelinePage } from "./pages/DeliveryTimelinePage";
import { TeamLoadPage } from "./pages/TeamLoadPage";
import { PartnerLoadPage } from "./pages/PartnerLoadPage";
import { useDashboard, useMe } from "./api/hooks";

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/d/:id" element={<DashboardRoute />} />
      </Route>
    </Routes>
  );
}

function HomeRoute() {
  const { data: me } = useMe();
  if (me && isGuestOnly(me.roles)) return <Navigate to="/d/calendar" replace />;
  return <CatalogPage />;
}

function DashboardRoute() {
  const { id } = useParams<{ id: string }>();
  const { data: me } = useMe();
  if (me && id && !canAccessDashboard(me.roles, id)) return <Navigate to="/d/calendar" replace />;
  if (id === "task-operations") return <TaskOperationsPage />;
  if (id === "calendar") return <CalendarPage />;
  if (id === "delivery-timeline") return <DeliveryTimelinePage />;
  if (id === "team-load") return <TeamLoadPage />;
  if (id === "partner-load") return <PartnerLoadPage />;
  return <ComingSoonPage id={id ?? ""} />;
}

function ComingSoonPage({ id }: { id: string }) {
  const { data } = useDashboard(id);
  return (
    <div>
      <h1>{data?.name ?? id}</h1>
      <p>This dashboard is registered in the catalog but isn't wired to real queries yet.</p>
    </div>
  );
}
